/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {Collaborator, Owner, OwnerInfo, convertCollaborationsToCollaborators} from 'auth/PermissionConstants';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {isOrganization} from 'constants/UserConstants';
import {OwnableInfo, UpdateOwnableParams} from 'create-components/OwnableConstants';
import {OwnableSettingsWithCollaborationsModal} from 'create-components/OwnableSettingsModal';
import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import TemplateCollectionActions from 'notebook/entry-templates/collections/TemplateCollectionActions';
import getProcedureUIString, {ProceduresStringKeys, StringCase} from 'procedures/ProceduresStringKeys';

import {TemplateCollectionGraphQL} from '../../../../graphql-fragments/notebook/templates/__generated/TemplateCollectionGraphQL';
import {CreateTemplateParams} from './TemplateCollectionDAO';
import {doesTemplateCollectionIncludeProcedures, getNumTemplatesOfType} from './TemplateCollectionTypesUtils';

interface Props {
  templateCollection: TemplateCollectionGraphQL;
  navigateOnSuccess?: boolean;
  onRequestClose: (...args: Array<any>) => any;
}

class ManageTemplateCollectionModal extends React.Component<Props> {
  _isMounted?: boolean;

  componentDidMount(): void {
    this._isMounted = true;
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  updateTemplateCollection = (data: CreateTemplateParams): JQueryPromise<any> =>
    TemplateCollectionActions.updateWithXHR(this.props.templateCollection.id, data);

  deleteTemplateCollection = (): JQueryPromise<any> =>
    TemplateCollectionActions.deleteWithXHR(this.props.templateCollection.id);

  getDisabledOwnerTooltipText = (): string => {
    const numRecipes = getNumTemplatesOfType(
      this.props.templateCollection,
      ModelTypeConstants.RECIPE_PROCEDURE
    );
    const numAssays = getNumTemplatesOfType(
      this.props.templateCollection,
      ModelTypeConstants.ASSAY_PROCEDURE
    );

    // Build the procedures description based on what actually exists
    const proceduresToMove = [];
    if (numRecipes > 0) {
      proceduresToMove.push(
        `${getProcedureUIString(ProceduresStringKeys.PROCEDURE, ProcedureType.RECIPE, {
          stringCase: StringCase.LOWER,
          plural: true,
        })}`
      );
    }
    if (numAssays > 0) {
      proceduresToMove.push(
        `${getProcedureUIString(ProceduresStringKeys.PROCEDURE, ProcedureType.ASSAY, {
          stringCase: StringCase.LOWER,
          plural: true,
        })}`
      );
    }
    const proceduresToMoveDescription = proceduresToMove.join(' and ');

    return `To change the owner, move ${proceduresToMoveDescription} to a different template collection.`;
  };

  render(): JSX.Element | null {
    const owner: Owner = this.props.templateCollection.ownerJson;
    const ownerInfo: OwnerInfo = {
      type: this.props.templateCollection.ownerInfoJson.type,
      memberDataPolicyId: this.props.templateCollection.ownerInfoJson.memberDataPolicyId || null,
    };
    const collaborators: Array<Collaborator> = this.props.templateCollection.collaboratorsJson.filter(
      (collaborator: any) => collaborator.id !== owner.id
    );

    const templateCollectableOwnable: OwnableInfo = {
      id: this.props.templateCollection.id,
      name: this.props.templateCollection.name,
      description: this.props.templateCollection.description,
      owner,
      ownerInfo,
      collaborators,
    };

    const shouldDisableChangeOwner =
      doesTemplateCollectionIncludeProcedures(this.props.templateCollection) && isOrganization(owner);

    return (
      <OwnableSettingsWithCollaborationsModal
        disableChangeOwner={shouldDisableChangeOwner}
        disabledOwnerTooltipText={shouldDisableChangeOwner ? this.getDisabledOwnerTooltipText() : undefined}
        navigateOnSuccess={this.props.navigateOnSuccess}
        onRequestClose={this.props.onRequestClose}
        existingOwnable={templateCollectableOwnable}
        ownableType={ModelTypeConstants.TEMPLATE_COLLECTION}
        ownableId={templateCollectableOwnable.id}
        isReadOnly={!this.props.templateCollection?.permissions?.admin}
        doSubmit={(data: UpdateOwnableParams) =>
          this.updateTemplateCollection({
            ...data,
            collaborators:
              data.collaborations &&
              convertCollaborationsToCollaborators(data.collaborations.filter((c) => !c.fromOwnership)),
          })
        }
        doDelete={
          !BenchlingConfig.ELN_ENABLE_TEMPLATE_ARCHIVING && BenchlingConfig.ENABLE_DELETE
            ? this.deleteTemplateCollection
            : null
        }
      />
    );
  }
}

export default ManageTemplateCollectionModal;
